import { defineComponent } from '@/components/base';
import CartNotice from '@/components/cart-notice/index';
import CartEvents from '@/components/cart-notice/events';

export default class QuizContext extends HTMLElement {
  static Events = {
    ChangeMainImage: 'ChangeMainImage',
    AddedToCart: 'AddedToCart'
  };
  static RegimenProfileKey = 'fob-regimen-profile';

  constructor() {
    super();
  }
  changeMainImage(img) {
    this.imageCorausel.firstSlideImage.src = img;
  }

  saveRegimenProfile(regimenObject) {
    localStorage.setItem(
      QuizContext.RegimenProfileKey,
      JSON.stringify(regimenObject)
    );
  }

  connectedCallback() {
    defineComponent('cart-notice', CartNotice);

    this.imageCorausel = this.querySelector('slider-carousel');
    this.cartNotice = this.querySelector('cart-notice');

    this.addEventListener(QuizContext.Events.AddedToCart, (e) => {
      !!this.cartNotice && this.cartNotice.show();
    });

    this.addEventListener(CartEvents.ContinueShopping, (e) => {
      !!this.cartNotice && this.cartNotice.hide();
    });
    this.addEventListener(CartEvents.ViewCart, (e) => {
      window.location.href = '/cart';
    });
  }
}
